export default [
  {
    path: '/control-ticket/transacciones/impresion-ticket-comedor',
    name: 'control-ticket-transacciones-impresion-comedor',
    component: () =>
      import ('@/views/pages/controlTicket/transacciones/ImpresionTickets.vue'),
    meta: {
			title: 'i18n:control_ticket.transacciones.impresion.titulo',
      layout: 'full',
      resource: 'Control Ticket',
      action: 'ver-control-ticket-transacciones-impresion-comedor',
      pageTitle: 'control_ticket.transacciones.impresion.titulo',
      breadcrumb: [
        {
          text: 'control_ticket.titulo',
          active: true
        },
        {
          text: 'Transacciones',
          active: true
        },
      ]
    },
  },
  {
    path: '/control-ticket/coniguracion/conexion-relojes',
    name: 'control-ticket-configuacion-relojes',
    component: () =>
      import ('@/views/pages/controlTicket/configuracion/TicketRelojes.vue'),
    meta: {
			title: 'i18n:control_ticket.configuracion.relojes.titulo',
      resource: 'Control Ticket',
      action: 'ver-control-ticket-configuracion-relojes',
      pageTitle: 'control_ticket.configuracion.relojes.titulo',
      breadcrumb: [
        {
          text: 'control_ticket.titulo',
          active: true,
        },
        {
          text: 'Configuracion',
          active: true,
        },
      ]
    },
  },
]
